import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

export const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.085, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (time) => {
      lenis.raf(time);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
};

export const scrollToTarget = (target, opts = {}) => {
  const el = typeof target === "string" ? document.querySelector(target) : target;
  if (target !== 0 && !el) return;
  if (window.__lenis) window.__lenis.scrollTo(target === 0 ? 0 : el, { offset: -72, ...opts });
  else if (target === 0) window.scrollTo(0, 0);
  else el.scrollIntoView({ behavior: "smooth" });
};

export const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      scrollToTarget(0, { immediate: true });
      return undefined;
    }
    const t = setTimeout(() => scrollToTarget(hash), 120);
    return () => clearTimeout(t);
  }, [pathname, hash]);
  return null;
};
